import styled from 'styled-components';

import EquipPreview from '~/src/features/full-buy/EquipPreview';

export const SEquipPreview = styled(EquipPreview)`
    margin-bottom: 0;
`;
